import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Program_learning = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 두뇌 톡톡`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/program_learning" className="sel">
                  두뇌 톡톡
                </a>
              </li>
              <li>
                <a href="/program_language">언어 톡톡</a>
              </li>
              <li>
                <a href="/program_inquiry">탐구(사회/역사)</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="program_learning process">
          <div className="sect process01 learning01">
            <div className="wrap">
              <div className="tit-wrap">
                <div className="tit init">
                  발달 수준에 맞는
                  <br />
                  학습 능력을 높여주는
                  <br />
                  <span>두뇌 톡톡 프로그램</span>
                </div>
              </div>
              <div className="img">
                <img
                  src="../custom-resources/img/img_process_learning01_img_ver2024.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect process02 learning02">
            <div className="wrap">
              <div className="tit init">
                아이들의 학습 능력은
                <br className="mo-view" /> 과도한 문제 풀이가 동반된{" "}
                <br className="pc-view" />
                선행 학습으로
                <br className="mo-view" /> 향상되는 것이 아닙니다.
              </div>
              <div className="txt init">
                <p>
                  학습 능력을 향상시키는 주요 요소는 뇌 기능 발달과 <br />
                  <span className="neon init">
                    어휘력, 이해력, 독해력, 문제 해결력, 주의력, 추리력
                  </span>
                  입니다.
                  <br />
                  <br />
                  아소비는 학습능력을 향상시키는 이 주요 요소들이
                  <br />잘 길러질 수 있도록 두뇌 톡톡 프로그램을 실시합니다.
                </p>
              </div>
            </div>
          </div>
          <div className="sect process03 learning03">
            <div className="wrap">
              <div className="tit init">
                퀴즈를 풀듯, 게임을 하듯 <br className="mo-view" />
                즐겁게 학습하는 과정에서 <br />
                균형 잡힌 두뇌 계발이 이루어집니다.
              </div>
            </div>
          </div>
          <div className="sect process04 learning04">
            <div className="wrap">
              <div className="brain">
                <div className="init">
                  <div className="image top type1">
                    <img
                      src="../custom-resources/img/img_process_learning04_icon01.png"
                      alt=""
                    />
                  </div>
                  <div className="desc desc01">
                    <div className="tit">생각하는 뇌</div>
                    <div className="txt">
                      주로 언어나 수학적 사고를 활용해 해결할 수 있는{" "}
                      <br className="mo-view" />
                      내용으로 구성되어 논리적 사고를 돕습니다.
                      <br />
                      <span>체계적이고 분석적인 기능의 영역</span>으로{" "}
                      <br className="mo-view" />
                      ‘생각하는 뇌’ 활동을 통해 <br className="pc-view" />
                      사고력 발달이 <br className="mo-view" />
                      왕성하게 이루어질 수 있습니다.
                      <br />
                      <br />
                      <span>탐구력, 수리력, 분석력, 문제 해결력</span> 등의{" "}
                      <br className="mo-view" />
                      학습 능력을 효과적으로 향상합니다.
                    </div>
                  </div>
                </div>
                <div className="init">
                  <div className="image type1">
                    <img
                      src="../custom-resources/img/img_process_learning04_icon02.png"
                      alt=""
                    />
                  </div>
                  <div className="desc desc02">
                    <div className="tit">상상하는 뇌</div>
                    <div className="txt">
                      <span>직관적으로 판단하고 창의적으로 상상</span>하여{" "}
                      <br className="mo-view" />
                      이미지와 관련된 정보를 처리합니다.
                      <br />
                      <br />
                      ‘상상하는 뇌’ 활동을 통해 어떤 문제에 직면했을 때<br />
                      스스로 해결책을 찾고 다양하게 생각해 보는{" "}
                      <br className="mo-view" />
                      <span>창조적 능력을 개발</span> 시킬 수 있습니다.
                    </div>
                  </div>
                </div>
                <div className="init">
                  <div className="image type1">
                    <img
                      src="../custom-resources/img/img_process_learning04_icon03.png"
                      alt=""
                    />
                  </div>
                  <div className="desc desc03">
                    <div className="tit">집중하는 뇌</div>
                    <div className="txt">
                      <span>집중하는 능력은 과제를 수행</span>하기 위해 마음이나
                      주의를 <br className="mo-view" />
                      우선적으로 쏟아내는 힘으로
                      <br />
                      학습에 있어서 꼭 필요한 능력입니다.
                      <br />
                      <br />
                      ‘집중하는 뇌’ 활동을 통해 <br className="mo-view" />
                      힘들거나 어렵다고 느껴지는 과제도
                      <br />
                      인내심을 가지고 학습 목표에 다다를 수 있도록
                      <br className="mo-view" />{" "}
                      <span>주의 집중력을 키우게</span> 됩니다.
                    </div>
                  </div>
                </div>
                <div className="init">
                  <div className="image type1">
                    <img
                      src="../custom-resources/img/img_process_learning04_icon04.png"
                      alt=""
                    />
                  </div>
                  <div className="desc desc04">
                    <div className="tit">추리하는 뇌</div>
                    <div className="txt">
                      추리하는 능력은{" "}
                      <span>
                        알고 있는 지식과 정보를 바탕으로{" "}
                        <br className="mo-view" />
                        새로운 문제를 해결
                      </span>
                      하는 힘입니다.
                      <br />
                      <br />
                      ‘추리하는 뇌’ 활동을 통해{" "}
                      <span>공간, 도형, 수열 추리력</span> 등을
                      <br />
                      효과적으로 높여 문제를 이해하고 <br className="mo-view" />
                      스스로 해결할 수 있게 됩니다.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sect process05 learning05">
            <div className="wrap">
              <div className="tit init">
                아소비에서만 만날 수 있는
                <br className="mo-view" /> 두뇌 톡톡 프로그램
              </div>
              <div className="txt init">
                하루 1시간, 과목별 고른 배분에 그로우 과정부터
                <br className="mo-view" /> 두뇌 톡톡 프로그램이 포함되어
                있습니다!
              </div>
              <a href="/process_grow" className="prcs_tit init green">
                그로우 과정
              </a>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_process_grow05_img01_2024.png"
                  alt=""
                />
              </div>
              <a href="/process_master" className="prcs_tit init pink">
                마스터 과정
              </a>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_process_master05_img01_2024.png"
                  alt=""
                />
              </div>
              <a
                href="/program_elementary1"
                className="prcs_tit init blue"
              >
                초등 과정
              </a>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_process_elementary01_img10_2024.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Program_learning;
